import React, { useEffect, useState } from 'react';
import { List, ListItem, Title } from '@icarros/ids-react';
import { useAdContext } from '../../../store/contexts/ad';
import { ListItemModifier, OpenEditTitleWrapper, OpenEditWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useQuery } from '@tanstack/react-query';
import { getDoors } from '../../../services/Edits.service';
import { GET_DOORS } from '../../../queries';

export function DoorsForm(): JSX.Element {
  const { setCurrentContent, loading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent } = useAdContext();
  const { portas = 5 } = currentAd?.veiculo || {};
  const [selectedRadio, setSelectedRadio] = useState(portas);

  const { data, isInitialLoading } = useQuery({
    queryKey: [GET_DOORS],
    queryFn: () => getDoors()
  });

  const doors = data?.map(item => ({
    nome: String(item),
    id: item
  }));

  useEffect(() => {
    setValueIsDifferentFromCurrent(selectedRadio !== portas);
  }, [selectedRadio, portas, setValueIsDifferentFromCurrent]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar dados do veículo</Title>
        <Title variant="default" contrast="light">
          quantas portas tem seu carro?
        </Title>
      </OpenEditTitleWrapper>

      {isInitialLoading && <Loading />}

      <List>
        {doors ? (
          doors.map(door => (
            <ListItemModifier key={door.nome}>
              <ListItem
                label={door.nome}
                variant="selector"
                radioOnChange={() => setSelectedRadio(door.id)}
                radioValue={door.id}
                radioChecked={door.id === selectedRadio}
                selectorName={door.nome}
                selectorVariant="radio"
              />
            </ListItemModifier>
          ))
        ) : (
          <></>
        )}
      </List>

      {!(isInitialLoading && selectedRadio === portas) && (
        <SaveFormContent
          loading={loading}
          isBody
          isDisabled={selectedRadio === portas}
          handleClick={() =>
            setCurrentContent({
              veiculo: {
                portas: selectedRadio
              }
            })
          }
        />
      )}
    </OpenEditWrapper>
  );
}
